import request from '@/utils/request'
import qs from 'qs'

const proxyUrl = process.env.Communityapi;
//活跃成员
export const circleMember = (data) => {
  return request({
	method: 'post',
	url:proxyUrl+'/circle/findMemberByCircleId',
	data: qs.stringify(data),
  })
};


// WEBPACK FOOTER //
// ./src/utils/api/active_members.js